<section *ngIf="recognitionStep === recognitionSteps.PreviewRecognition" id="preview-recognition">
  <app-camera-selector (cameraSelection)="onCameraSelected($event)" (errorType)="errorType" (closeCameraSelection)="close()"></app-camera-selector>

  <!-- <div class="alert alert-warning" *ngIf="availableCameras.length === 0 && camerasChecked">
    <img src="../../../assets/images/icons/warning-modal.png" alt="">
    {{'faceRecognition.errors.noCamerasDetected' | translate}}
  </div> -->
</section>

<!-- Sección principal: solo cuando está en el paso de reconocimiento -->
<section *ngIf="recognitionStep === recognitionSteps.Recognizing" id="recognizing">
  <section class="detail__close-modal">
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </section>

  <section class="detail-access-modal">
    <section class="full-container p-4 face-recognition-scan text-center">
      <div class="flex-container flex-direction-column justify-content-start w-100">
        <div *ngIf="!gettingDescriptor && cameraReady" class="text-container">
          <h5 *ngIf="isAGoodFrame()" class="text-center h5_500 suggestionText wavy-text">{{ suggestionText | translate }}</h5>
          <h5 *ngIf="!isAGoodFrame()" class="text-center h5_500 suggestionText invalid">{{ suggestionText | translate }}</h5>
        </div>
        <div *ngIf="!gettingDescriptor" style="position: relative;">
          <div *ngIf="cameraLoading && !gettingDescriptor" class="cameras-loading">
            <h5 class="text-center h5_500 suggestionText">{{ 'faceRecognition.loadings.accessingTheCamera' | translate }}</h5>
            <ng-lottie [options]="animationOptions" (animationCreated)="animationCreated($event)" [height]="'300px'" [width]="'300px'"></ng-lottie>
          </div>
          <div *ngIf="!cameraLoading" class="camera-container" [ngClass]="{'not-positioned': !isAGoodPosition()}">
            <video *ngIf="!photoCaptured && cameraReady" id="videoElement" #videoElement muted playsinline></video>
            <img *ngIf="photoCaptured && !gettingDescriptor" [src]="photoControl.value" alt="Captured Photo"/>
          </div>
          <!-- Círculo de escaneo -->
          <div *ngIf="scanning && cameraReady" class="scan-circle">
            <div *ngFor="let line of scanLines; let i = index" class="scan-line" [ngClass]="{'active': i < activeScanLines, 'error': !isAGoodFrame()}" [ngStyle]="{'transform': 'rotate(' + (i * (360 / totalLines)) + 'deg) translateY(-196px)'}"></div>
          </div>
        </div>
        <div *ngIf="gettingDescriptor" class="cameras-loading">
          <h5 class="text-center h5_500 suggestionText">{{ 'faceRecognition.loadings.verifyingFace' | translate }}</h5>
          <ng-lottie [options]="animationOptions" (animationCreated)="animationCreated($event)" [height]="'300px'" [width]="'300px'"></ng-lottie>
        </div>
      </div>
      <button *ngIf="scanning && cameraReady" mat-icon-button class="select-camera" (click)="resetRegistration()">
        <mat-icon class="material-symbols-rounded camera-icon">keyboard_arrow_down</mat-icon>
        <mat-icon class="material-symbols-rounded camera-icon">photo_camera</mat-icon>
      </button>
    </section>
  </section>
</section>

<!-- Sección de error: solo cuando el reconocimiento falló -->
<section *ngIf="recognitionStep == recognitionSteps.RecognitionFailed" id="recognition-failed">
  <app-error-mannagment [invalidations]="invalidations" [errorType]="errorType" (cancelRegistration)="cancelRegistration()" (resetRegistration)="resetRegistration()"></app-error-mannagment>
</section>